import { FormatStringDataType, TrimFull, xmlSetAttribute } from "./rpwCommonFuncs";

export function MakeLegalStart(itemNodes) {
	var legaldescription = "";
	var legaldescriptionPolaris = "";
	var shortlegaldesc = "";
	var shortlegaldescPolaris = "";
	var pins ="";
    var ldesc = itemNodes.selectSingleNode("LegalDescriptionInput");
	var i ;
	if (itemNodes.getAttribute("PropertyType") === "Condo") {
        var UnitNodes=ldesc.selectNodes("Unit[@Plan and not(not(@Type)) and not(@Type='')]");
        for (i = 0; i < (UnitNodes.length); i++)
        {
            var CondoPlanSpace = UnitNodes[i].getAttribute("Plan").indexOf(" ");
            var CondoPlanLength = UnitNodes[i].getAttribute("Plan").length;
            if (CondoPlanSpace === -1)
            {
            }
            else
            {	
                var CondoPlanNumber=""+UnitNodes[i].getAttribute("Plan");	
                CondoPlanNumber=CondoPlanNumber.substr(CondoPlanSpace+1, CondoPlanLength);
                const corp = "" + itemNodes.getAttribute("CondoCorp");
                var wordArray = corp.split(' ');
                var corpPlan = '';
                for (let j = 0; j < (wordArray.length-1);j++)
                    corpPlan= corpPlan+wordArray[j] +" ";
                
                corpPlan=corpPlan+'Plan '+ CondoPlanNumber;
                UnitNodes[i].setAttribute("PlanPolaris", corpPlan);
            }
        }	


        var units = ldesc.selectNodes("Unit[@Plan and not(not(@Type)) and not(@Type='')]");
        var unit;			
        var plans = [];
        var plansPolaris = [];
        while ((unit = units.nextNode()) != null)
        {
            if (!searchArray(plans,unit.getAttribute("Plan")))
            {
                plans[plans.length]=unit.getAttribute("Plan");
            }	
            if (!searchArray(plansPolaris,unit.getAttribute("PlanPolaris")))
            {
                plansPolaris[plansPolaris.length]=unit.getAttribute("PlanPolaris");
            }	
        }	
        for (i = 0; i < (plans.length); i++) {
            units = ldesc.selectNodes("Unit[@Plan='"+plans[i]+"' and not(not(@Type)) and not(@Type='')]");
            if (i >0) {
                shortlegaldesc +=" and "										
            }
            let j = 0;
            while ((unit = units.nextNode()) != null && unit.getAttribute("Type") != null && unit.getAttribute("Type") !== "") {
                if (j >0) {
                    shortlegaldesc +=", "										
                }

                if (unit.getAttribute("Unit") !== null && unit.getAttribute("Unit") !== "")
                    shortlegaldesc += "Unit " + unit.getAttribute("Unit");
                if (unit.getAttribute("Level") !== null && unit.getAttribute("Level") !== "")
                    shortlegaldesc += ", Level " + unit.getAttribute("Level");
                j++;
                if (unit.getAttribute("PIN") !== "") {
                    if (pins !== "")
                        pins+=","
                    pins += unit.getAttribute("PINBlock") +"-" + unit.getAttribute("PINProperty");				
                }	
            }
            shortlegaldesc += ", " +plans[i];
        }	

// *************************************************************
// *************************************************************
// *************************************************************
        var isMultiUnit = false;
        // var newLegalFullCorp = "";
        for (  i = 0; i < (plansPolaris.length); i++) {
            units = ldesc.selectNodes("Unit[@PlanPolaris='"+plansPolaris[i]+"']");
            if (i >0) {
                shortlegaldescPolaris +=" and ";
                // newLegalFullCorp += " and ";								
            }
            var j = 0;
            while ((unit = units.nextNode()) != null && unit.getAttribute("Type") !== null && unit.getAttribute("Type") !== "") {
                if (j >0) {
                    shortlegaldescPolaris +=", ";
                    // newLegalFullCorp += " and ";										
                    isMultiUnit = true;
                }
                else
                    isMultiUnit = false;
                shortlegaldescPolaris += "Unit "+unit.getAttribute("Unit") + ", Level " + unit.getAttribute("Level"); 
                // newLegalFullCorp += "Unit "+unit.getAttribute("Unit") + ", Level " + unit.getAttribute("Level"); 
                j++;
            }
            // newLegalFullCorp += ", "+plansPolaris[i];
            if(isMultiUnit === true)
                shortlegaldescPolaris += "\ntogether with their appurtenant common interests\n" +plansPolaris[i];
            else
                shortlegaldescPolaris += "\ntogether with its appurtenant common interest\n" +plansPolaris[i];
        }
	} else {
		if (ldesc != null)
		 	var lot = ldesc.selectSingleNode("Lot");
		if (lot != null) {
			var part = lot.getAttribute("LotBlockWord");
			if (part !== "notstd") {
			    if (part !== null && part !== "")
			        shortlegaldesc += part;
			    if (lot.getAttribute("LotBlock") !== null && lot.getAttribute("LotBlock") !== "")
				    shortlegaldesc += " "+ lot.getAttribute("LotBlock");
			    if (lot.getAttribute("Plan") !== null && lot.getAttribute("Plan") !== "")
			        shortlegaldesc += ", Plan " + lot.getAttribute("Plan");
                if(part !== null && part !== "")
				    shortlegaldescPolaris += part;
				if (lot.getAttribute("LotBlock") !== null && lot.getAttribute("LotBlock") !== "")
				    shortlegaldescPolaris += " " + lot.getAttribute("LotBlock");
				if (lot.getAttribute("Plan") !== null && lot.getAttribute("Plan") !== "")
				    shortlegaldescPolaris += ", Plan " + lot.getAttribute("Plan");
				if ((part === "Part(s) of Lot(s)" || part === "Part(s) of Block(s)") && lot.getAttribute("Part") !== null && lot.getAttribute("Part") !== "")
				{
					shortlegaldesc += ", designated as a Part(s) "+ lot.getAttribute("Part");		
					if (lot.getAttribute("RefPlan") !== null && lot.getAttribute("RefPlan") !== "")
					    shortlegaldesc += " on Reference Plan " + lot.getAttribute("RefPlan");
					shortlegaldescPolaris += ", designated as a Part(s) "+ lot.getAttribute("Part");		
					if (lot.getAttribute("RefPlan") !== null && lot.getAttribute("RefPlan") !== "")
					    shortlegaldescPolaris += " on Reference Plan " + lot.getAttribute("RefPlan");
				}
				if(itemNodes.getAttribute("twCommonElements") === "1")
				{
					shortlegaldesc += ", together with an undivided common interest in " + itemNodes.getAttribute("CondoCorpShort") + " Corporation No. " + itemNodes.getAttribute("CondoCorpNumber");		
					shortlegaldescPolaris += ", together with an undivided common interest in " + itemNodes.getAttribute("CondoCorpShort") + " Corporation No. " + itemNodes.getAttribute("CondoCorpNumber");		
				}
			
			}
			else {
				shortlegaldesc += lot.getAttribute("NoStandardDescription");
				shortlegaldescPolaris += lot.getAttribute("NoStandardDescription");
			}
		}
	}

	itemNodes.setAttribute("ShortLegalDesc", shortlegaldesc);
	if (shortlegaldesc === null || shortlegaldesc === "")
	    legaldescription += MakeMunicipalityLegalDescLine(itemNodes, ldesc);
	else
	    legaldescription += shortlegaldesc + ", " + MakeMunicipalityLegalDescLine(itemNodes, ldesc);

	legaldescriptionPolaris += shortlegaldescPolaris + "\n\n" + itemNodes.getAttribute("LongLegalDescPolaris");
    itemNodes.setAttribute("PropertyPIN", pins);
	itemNodes.setAttribute("LegalDescription", legaldescription);
	itemNodes.setAttribute("LegalDescriptionPolaris", legaldescriptionPolaris);
}

function searchArray(a,v) {
	var retval = false;
	for (let searchCounter =0; searchCounter < a.length; searchCounter++) {
		if (a[searchCounter] === v) {
			retval =  true;
			break;
		}	
	}		
	return retval;		
}

function MakeMunicipalityLegalDescLine(itemNode, item) {
	var MunicipalityLegalDescLine = item.getAttribute("Municipality");
	if(MunicipalityLegalDescLine == null)
		MunicipalityLegalDescLine = "";
	var municcounty = item.getAttribute("County");
	if(municcounty !== null && municcounty !== "") {
		if(MunicipalityLegalDescLine !== "")
			MunicipalityLegalDescLine += ", ";
		MunicipalityLegalDescLine += municcounty;
	}
	itemNode.setAttribute("MunicipalityLegalDescLine", MunicipalityLegalDescLine);
	return MunicipalityLegalDescLine;
}

export function MakeAddress(itemNodes) {
	var ClientPortal = itemNodes.selectSingleNode("ClientPortal");
	if (ClientPortal) {
		if (itemNodes.getAttribute("isisRemoteSigningOverWrite") !== "1") {
			if (ClientPortal.getAttribute("isClientPortalActive") === "1" && ClientPortal.getAttribute("RemoteClosingAppointmentTime") > "" && ClientPortal.getAttribute("RemoteClosingAppointmentDate") > "") {
				itemNodes.setAttribute("isRemoteSigning", "1");
			}
			else {
				itemNodes.setAttribute("isRemoteSigning", "0");
			}
		}
	} else if (itemNodes.getAttribute("isisRemoteSigningOverWrite") !== "1") {
		itemNodes.setAttribute("isRemoteSigning", "0");
	}

	itemNodes = itemNodes.selectSingleNode("Property");
	var address = "";
		
	if (itemNodes)
	{
		if (itemNodes.getAttribute("StreetNumber") !== "" && itemNodes.getAttribute("StreetNumber") !== null)
		{
			address = itemNodes.getAttribute("StreetNumber");
		}
		if (itemNodes.getAttribute("StreetNumberSuffix") !== "" && itemNodes.getAttribute("StreetNumberSuffix") !== null)
		{
			address += itemNodes.getAttribute("StreetNumberSuffix");
		}
		if (itemNodes.getAttribute("StreetName") !== "" && itemNodes.getAttribute("StreetName") !== null)
		{
			address +=" " + itemNodes.getAttribute("StreetName");
		}
		if (itemNodes.parentNode.getAttribute("ApplicationSubCode") === "ON" || itemNodes.parentNode.getAttribute("ApplicationSubCode") === "BC") {
			if (itemNodes.parentNode.getAttribute("PropertyType") === "Condo" && itemNodes.getAttribute("UnitNumber") !== "" && itemNodes.getAttribute("UnitNumber") !== null)
			{
				address = itemNodes.getAttribute("UnitNumber") + ", " + address;
			}
			if (itemNodes.parentNode.getAttribute("PropertyType") === "Condo" && itemNodes.getAttribute("UnitType") !== "" && itemNodes.getAttribute("UnitType") !== null)
			{
				address = itemNodes.getAttribute("UnitType") + " " + address;
			}
			
		} else {
			if (itemNodes.parentNode.getAttribute("PropertyType") === "Condo" && itemNodes.getAttribute("UnitType") !== "" && itemNodes.getAttribute("UnitType") !== null)
			{
				address +=", " + itemNodes.getAttribute("UnitType");
			}
			if (itemNodes.parentNode.getAttribute("PropertyType") === "Condo" && itemNodes.getAttribute("UnitNumber") !== "" && itemNodes.getAttribute("UnitNumber") !== null)
			{
				address +=" " + itemNodes.getAttribute("UnitNumber");
			}
		}
		if (itemNodes.getAttribute("City") !== "" && itemNodes.getAttribute("City") !== null)
		{
			address +=", " + itemNodes.getAttribute("City");
		}
		address +=", Ontario";
		if (itemNodes.getAttribute("PostalCode") !== "" && itemNodes.getAttribute("PostalCode") !== null)
		{
			address +="  " + itemNodes.getAttribute("PostalCode");
		}
		itemNodes.parentNode.setAttribute("PropertyAddress",address)
	}
}


export async function LoadMunicByName(muniname, tpnode, sid) {
	var bCityExists = false;
    try {
        var res = await fetch("getxml.asp?query=FindMunic&name=" + escape(muniname.replace(/'/g, "''")) + `&SessionID=${sid}&compat=1`);
        var text = await res.text();
        if (res != null) {
            var xmlMunic = new ajaxslt.XDocument()
            xmlMunic.loadXML(text);
            var municNodes = xmlMunic.selectNodes("/Root/Data/Root/munic");
            var municxmlNode = null;
            // Find first munic node without ownerID
            for (let i = 0; i < municNodes.length; i++) {
                if (municNodes[i].getAttribute("OwnerID")) {
                    municxmlNode = municNodes[i];
                    break;
                }
            }
			if (!municxmlNode && municNodes.length > 0) {
				municxmlNode = municNodes[0];
			}
            if (municxmlNode != null) {
                var municid = municxmlNode.getAttribute("MunicID");
                res = await fetch("getxml.asp?tb=munic&id=" + municid + `&SessionID=${sid}&compat=1`);
                if (res != null) {
                    text = await res.text();
                    xmlMunic.loadXML(text);
                    municxmlNode = xmlMunic.selectSingleNode("/Root/Data/munic");

                    if (municxmlNode != null) {
                        var oldMunicNode = tpnode.selectSingleNode("munic");
                        if (oldMunicNode != null)
                            tpnode.replaceChild(municxmlNode.cloneNode(true), oldMunicNode);
                        else
                            tpnode.appendChild(municxmlNode.cloneNode(true));
                        bCityExists = true;
                        var MyRegofficeID = tpnode.selectSingleNode("munic").getAttribute("RegistryOfficeID");
                        if (MyRegofficeID > "")
                            tpnode.setAttribute("RegistryOfficeID", MyRegofficeID);
                    }
                }
            } else {
                var myName = FormatStringDataType(muniname, "title");
                var send = false;
                if (myName.indexOf("City Of") !== -1) {
                    myName = myName.replace("City Of", "");
                    myName = TrimFull(myName) + " (City)";
                    send = true;
                }
                else if (myName.indexOf("Township Of") !== -1) {
                    myName = myName.replace("Township Of", "");
                    myName = TrimFull(myName) + " (Township)";
                    send = true;
                }
                else if (myName.indexOf("Municipality Of") !== -1) {
                    myName = myName.replace("Municipality Of", "");
                    myName = TrimFull(myName) + " (Municipality)";
                    send = true;
                }
                else if (myName.indexOf("County Of") !== -1) {
                    myName = myName.replace("County Of", "");
                    myName = TrimFull(myName) + " (County)";
                    send = true;
                }
                else if (myName.indexOf(" (Township)") !== -1) {
                    myName = myName.replace(" (Township)", "");
                    send = true;
                }
                else if (myName.indexOf(" (Municipality)") !== -1) {
                    myName = myName.replace(" (Municipality)", "");
                    myName = "City Of " + TrimFull(myName);
                    send = true;
                }
                else if (myName.indexOf(" (City)") !== -1) {
                    myName = myName.replace(" (City)", "");
                    send = true;
                }
                else if (myName.indexOf(" (County)") !== -1) {
                    myName = myName.replace(" (County)", "");
                    send = true;
                }
                if (send) {
                    myName = TrimFull(myName);
                    if (myName[myName.length - 1] === ",")
                        myName = myName.substring(0, myName.length - 1);
                    bCityExists = LoadMunicByName(myName, tpnode, sid);
                }
            }
        }
    } catch (e) {
        console.log(e);
    }
	
	return bCityExists;
}

export function ResetMunicRecord(itemNodes, sid)
{
	
	var pnode = itemNodes.selectSingleNode("Property");

	var newMunicNode = itemNodes.selectSingleNode("munic");	
	xmlSetAttribute(itemNodes, "City", newMunicNode.getAttribute("Name"), "");
	if (pnode) xmlSetAttribute(pnode, "City", newMunicNode.getAttribute("Name"), "");
	
	var legalinput  = itemNodes.selectSingleNode("LegalDescriptionInput");
	if(legalinput==null)
	{
		legalinput = itemNodes.ownerDocument.createElement("LegalDescriptionInput");
		legalinput = itemNodes.appendChild(legalinput);
	}
		
	xmlSetAttribute	(legalinput, "Municipality", newMunicNode.getAttribute("FullName"), "");
	xmlSetAttribute	(legalinput, "County", newMunicNode.getAttribute("County"), "");
	xmlSetAttribute	(itemNodes, "RegistryOfficeID", newMunicNode.getAttribute("RegistryOfficeID"), "");
	

//****************************** REGISTRY OFFICE HERE***************
	CreateRegistryOffice(itemNodes, sid);
//	itemNodes.parentNode.setAttribute("LandRegistryOffice", itemNodes.selectSingleNode("RegistryOffice").getAttribute("FullName"));
//	itemNodes.parentNode.setAttribute("RegistryOfficeID", newMunicNode.getAttribute("RegistryOfficeID"));
	xmlSetAttribute (itemNodes, "AssessmentRollNoCity", newMunicNode.getAttribute("AssessRoll1"), "");
	xmlSetAttribute (itemNodes, "AssessmentRollNoMunicipality", newMunicNode.getAttribute("AssessRoll2"), "");

	var MunicipalityLegalDescLine = newMunicNode.getAttribute("FullName");
	if(MunicipalityLegalDescLine == null)
		MunicipalityLegalDescLine = "";
	var municcounty = newMunicNode.getAttribute("County");
	if(municcounty !== null && municcounty !== "")
	{
		if(MunicipalityLegalDescLine !== "")
			MunicipalityLegalDescLine += ", ";
		MunicipalityLegalDescLine += municcounty;
	}
	itemNodes.setAttribute("MunicipalityLegalDescLine", MunicipalityLegalDescLine);
}

async function CreateRegistryOffice(item, sid)
{ 
	var registryNodes = item.selectSingleNode("munic");
	var roID = registryNodes.parentNode.getAttribute("RegistryOfficeID");
	if(roID > "")
	{
		var oldRegistryOfficeNode = registryNodes.selectSingleNode("RegistryOffice");
		
		// TODO: Variable nomenclature is slightly off for oldRegistryOfficeNode. 
		// It's technically not the old ID the new RegistryOfficeID is set in TPAppXML in ResetMunicRecord() before arriving here

		// if (oldRegistryOfficeNode) {
		// 	var municRegistryOfficeID = oldRegistryOfficeNode.getAttribute("RegistryOfficeID");
		// 	if (municRegistryOfficeID === roID) return;
		// }
		
		var res = await fetch("getxml.asp?tb=RegistryOffice&id="+roID+`&SessionID=${sid}&compat=1`);
        const xmlRegistryOffice = new ajaxslt.XDocument();
        xmlRegistryOffice.loadXML(await res.text());
		if(xmlRegistryOffice && xmlRegistryOffice.documentElement)
		{
			var newRegistryOfficeNode = xmlRegistryOffice.documentElement.selectSingleNode("Data/RegistryOffice");	
			if (newRegistryOfficeNode)
			{
				if (oldRegistryOfficeNode != null)
				{
					registryNodes.removeChild(oldRegistryOfficeNode);
					registryNodes.appendChild(newRegistryOfficeNode);
				}
				else
				{
					registryNodes.appendChild(newRegistryOfficeNode);
				}
				if(newRegistryOfficeNode.getAttribute("ShortName") != null)
					registryNodes.parentNode.setAttribute("LandRegistryOffice", newRegistryOfficeNode.getAttribute("ShortName"));
				else
					registryNodes.parentNode.setAttribute("LandRegistryOffice", newRegistryOfficeNode.getAttribute("Name"));
			}
		}
	}
}
